const structure = 
    [
        {
            name: '1/0/1',
            value: null
        },
        {
            name: '1/0/2',
            value: null,
        },
        {
            name: '1/0/3',
            value: null,
        },
        {
            name: '1/0/4',
            value: null,
        },
        {
            name: '1/0/5',
            value: null,
        },
        {
            name: '1/0/6',
            value: null,
        },
        {
            name: '1/0/7',
            value: null,
        },
        {
            name: '1/0/8',
            value: null,
        },
        {
            name: '1/0/9',
            value: null,
        },
        {
            name: '1/0/10',
            value: null,
        },
        {
            name: '1/0/11',
            value: null,
        },
        {
            name: '1/0/12',
            value: null,
        },
        {
            name: '1/0/13',
            value: null,
        },
        {
            name: '1/0/14',
            value: null,
        },
        {
            name: '1/0/15',
            value: null,
        },
        {
            name: '1/0/16',
            value: null,
        },
        {
            name: '1/0/17',
            value: null,
        },
        {
            name: '1/0/18',
            value: null,
        },
        {
            name: '1/0/19',
            value: null,
        },
        {
            name: '1/0/20',
            value: null,
        },
        {
            name: '1/0/21',
            value: null,
        },
        {
            name: '1/0/22',
            value: null,
        },
        {
            name: '1/0/23',
            value: null,
        },
        {
            name: '1/0/24',
            value: null,
        }
    ];

export default structure
